__turbopack_context__.v({
  "buttonContainer": "TrackThumbnail-module-scss-module__ag6xwW__buttonContainer",
  "playing": "TrackThumbnail-module-scss-module__ag6xwW__playing",
  "playlistTrackThumbnail": "TrackThumbnail-module-scss-module__ag6xwW__playlistTrackThumbnail",
  "selected": "TrackThumbnail-module-scss-module__ag6xwW__selected",
});
